module.exports = __webpack_public_path__ + "img/feature_04.a8e638c5.jpg";